export default "__VITE_ASSET__BfXW7AXn__"